/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import get from 'lodash/get';
import compose from 'lodash/fp/compose';
import defaultsDeep from 'lodash/defaultsDeep';
import { getPrefilledSolution } from '../../../utils/getPrefilledSolutionValue';
import { SOLUTIONS_DICTIONARIES as dict } from '../../../utils/dictionarykeys';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import { processLinkData } from '../../../utils/analytics';
import { getWildcardData } from '../../../utils/wildcards';
import OpenEnquiryFormButton from '../../ui/OpenEnquiryFormButton';
import { StickyBarConsumer } from '../../../contexts/StickyBarContext';
import { withConsumer } from '../../../contexts';
import * as styles from './index.styles';

const defaultData = {
  Headline: {
    value: '',
  },
  NumberOfNearbyLocations: 0,
  Subtitle: [],
  HeroImage1: {
    value: {
      src: '',
      alt: '',
    },
  },
  HeroImage2: {
    value: {
      src: '',
      alt: '',
    },
  },
  Description: {
    value: '',
  },
  PhoneNumber: {
    value: '',
  },
  HowManyPeopleOptions: [],
  MoveInDateOptions: [],
  GetInTouchCTA: {
    value: {
      href: '',
      linktype: '',
      text: '',
      anchor: '',
      querystring: '',
      target: '',
    },
  },
};

export class CTA extends SafePureComponent {
  stickyBarTriggerRef = React.createRef();

  constructor(props) {
    super(props);

    this.fields = defaultsDeep(this.props.rendering.fields, defaultData);
    this.state = {
      pageContainsSolutionsCards: false,
    };

    this.howManyPeopleSelect = React.createRef();
    this.moveInDateSelect = React.createRef();
    this.wildcards = getWildcardData(this.props.sitecoreContext);
  }

  // TODO: getEnquiryDefaultValues was duplicated on StickyBar in order to finish
  // this asap for demo but this should be moved to a global util in order to DRY.
  getEnquiryDefaultValues = (fields, prefilledSolution) => {
    const { t } = this.props;
    return {
      Location: get(fields, 'GeoName.value', ''),
      HowManyPeople: get(
        this.howManyPeopleSelect,
        'current.state.selectedLabel',
        '',
      ),
      MoveInDate: get(this.moveInDateSelect, 'current.state.selectedLabel', ''),
      Solution: get(
        prefilledSolution,
        'fields.Label.value',
        t(dict.OFFICE_SPACE),
      ),
    };
  };

  safeRender() {
    const prefilledSolution = getPrefilledSolution(this.props.sitecoreContext);
    const componentName = get(this.props, 'rendering.componentName', '');
    const openEnquiryFormButtonProps = {
      linkObject: this.fields.Link,
      prefilledValues: this.getEnquiryDefaultValues(
        this.fields,
        prefilledSolution,
      ),
      customCss: styles.primaryButton,
    };
    return (
      <OpenEnquiryFormButton
        {...openEnquiryFormButtonProps}
        componentName={componentName}
      />
    );
  }
}

CTA.displayName = 'CTA';

CTA.defaultProps = {
  rendering: {
    fields: defaultData,
  },
  t: key => key,
  stickyBarContext: {
    showStickyBar() {},
    hideStickyBar() {},
  },
};

export default compose(
  withSitecoreContext(),
  withNamespaces(),
  withConsumer(StickyBarConsumer, 'stickyBarContext'),
)(CTA);
